/** Created by azhou on 2019/3/14.*/
<template>
  <div class="show-level-wrap">
    <p class="text-right pr-5 mt-5"><span class="text-link h4" @click="$emit('closePanel')">关闭</span></p>
    <div id="AccountLevel" class="text-left"></div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts')
  //按需引入树形控件
  require('echarts/lib/chart/tree')
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  export default {
    name: 'AccountStructure',
    computed:{
      ...mapState(['accountStructure'])
    },
    watch: {
      accountStructure (newVal) {
        if (newVal.name) this.initEchart()
      }
    },
    methods: {
      /*初始化echart图表*/
      initEchart () {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init($('#AccountLevel').get(0))
        let option = {
          tooltip: {
            trigger: 'item',
            triggerOn: 'mousemove',
            formatter: (params, ticket, callback) => {
              return `账号：${params.data.name}<br />手机号：${params.data.mobile}`
            }
          },
          series: [
            {
              type: 'tree',
              data: [this.accountStructure],
              top: '1%',
              left: '15%',
              bottom: '1%',
              right: '20%',
              symbolSize: 15,
              label: {
                normal: {
                  position: 'left',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 16,
                  backgroundColor: '#ddd'
                }
              },
              leaves: {
                label: {
                  normal: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left'
                  }
                }
              },
              expandAndCollapse: true,
              animationDuration: 550,
              animationDurationUpdate: 750
            }
          ]
        }
        // 绘制图表
        myChart.setOption(option)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .show-level-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ddd;
    z-index: 3;
  }

  #AccountLevel {
    height: calc(100vh - 40px);
  }
</style>
